import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChange, logOut as firebaseLogOut } from '../firebase/auth';
import { resolveAuthContext } from '../firebase/userProfile';
import { ROLES } from '../firebase/userProfile';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [tenantId, setTenantId] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChange(async (firebaseUser) => {
      setUser(firebaseUser);
      if (!firebaseUser) {
        setRole(null);
        setTenantId(null);
        setTenant(null);
        setLoading(false);
        return;
      }
      try {
        const ctx = await resolveAuthContext(firebaseUser.uid, firebaseUser.email || '');
        setRole(ctx.role);
        setTenantId(ctx.tenantId);
        setTenant(ctx.tenant);
      } catch (err) {
        console.error('Auth context resolve error:', err);
        setRole(null);
        setTenantId(null);
        setTenant(null);
      } finally {
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const logOut = async () => {
    await firebaseLogOut();
    setUser(null);
    setRole(null);
    setTenantId(null);
    setTenant(null);
  };

  const isSuperAdmin = () => role === ROLES.SUPER_ADMIN;
  const isTenantAdmin = () => role === ROLES.TENANT_ADMIN;
  const getTenantId = () => tenantId;

  const value = {
    user,
    role,
    tenantId,
    tenant,
    loading,
    isSuperAdmin,
    isTenantAdmin,
    getTenantId,
    logOut
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return ctx;
}
